import React from 'react';
import Client from './../Client';
import BackofficeReportsApi from './backofficeReportsApi';
import PromotionKpiCard from './PromotionKpiCard';

class OverviewOpenClaims extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      data: {},
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.periodMode !== this.props.periodMode) {
      this.loadData();
    }
  }

  getPeriodLabel = () => {
    const periodMode = this.props.periodMode || "last_30d";

    if (periodMode === "last_7d") return "last 7d";
    if (periodMode === "last_90d") return "last 90d";

    return "last 30d";
  };

  loadData = () => {
    const periodMode = this.props.periodMode || "last_30d";

    let queryData = {
      periodMode: periodMode,
    };

    let data = BackofficeReportsApi.getPromotionsKpiSummary(this.state.client, queryData);

    if (data) {
      this.setState({ data: data });
    }
  };

  render() {
    const data = this.state.data || {};

    const openClaims = data.open_claims || 0;
    const claimsCreated = data.claims_created || 0;

    return (
      <PromotionKpiCard
        title="Open claims"
        value={openClaims}
        badge={`${claimsCreated} issued`}
        caption={`${this.getPeriodLabel()} · unused`}
        change={data.open_claims_change}
        color="#607d8b"
      />
    );
  }
}

export default OverviewOpenClaims;
